export const GLOBAL_NULL = '@@MISSING@@';
export const DEFAULT_NULL_VALUES = {
  STRING: GLOBAL_NULL,
  ENUMERATION: GLOBAL_NULL,
  BOOL: 0,
  CURRENCY: 0,
  NUMBER: Number.MIN_SAFE_INTEGER,
  PERCENT: 0
};